import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import SelectorChip from 'components/DesignSystem/SelectorChip';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import { useListSimilarityVariablesQuery } from 'services/api/Meteorology/Weather/Similarity';
import {
  setVariavel,
  setMeses,
  selectSimilaridadeVariavel,
  selectSimilaridadeMeses,
} from 'redux/reducers/similaridadeReducer';

import MONTHS from '../months';

import './index.scss';

export default function ConfigSheet({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  const dispatch = useDispatch();

  const selectedVariable = useSelector(selectSimilaridadeVariavel);
  const selectedMonths = useSelector(selectSimilaridadeMeses);
  const selectedMonth = selectedMonths[0];

  const { data: variables = [] } = useListSimilarityVariablesQuery();

  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Configuração"
      className="agro-simil-config-sheet"
    >
      <div className="agro-simil-config-sheet-body">
        <span className="agro-simil-config-sheet-label">Variável</span>
        <div className="agro-simil-config-sheet-options">
          {variables.map((v) => {
            const label = v.nome || v.label;
            return (
              <OptionRow
                key={v.id}
                label={label}
                selected={label === selectedVariable}
                onSelect={() => dispatch(setVariavel(label))}
              />
            );
          })}
        </div>

        <span className="agro-simil-config-sheet-label">
          Mês
          <span className="agro-simil-config-sheet-label-hint"> · seleção única</span>
        </span>
        <div className="agro-simil-config-sheet-months">
          {MONTHS.map((month) => (
            <SelectorChip
              key={month.value}
              shape="cell"
              selected={month.value === selectedMonth}
              onClick={() => dispatch(setMeses([month.value]))}
            >
              {month.abbr}
            </SelectorChip>
          ))}
        </div>
      </div>

      <div className="agro-simil-config-sheet-footer">
        <button
          type="button"
          className="agro-simil-config-sheet-apply"
          onClick={dismiss}
        >
          Aplicar
        </button>
      </div>
    </BottomSheet>
  );
}
